import { useState } from 'react'
import { Button } from '@mui/material'

import { DeleteConfirmModal } from './delete-confirm-modal'

import { useStyles } from './styles'
import { useRemoveMe } from 'src/hooks/users/use-remove-me.hook'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from '../helper-wrapper'

const DeleteButton = () => {
  const [open, setOpen] = useState(false)
  const { mutateAsync: removeMe } = useRemoveMe()
  const classes = useStyles()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleDelete = async () => {
    const resp = await removeMe()
    if (!resp) return
    handleClose()
  }

  return (
    <>
      <div className={`${classes.itemBorder} ${classes.deleteButtonWrapper}`}>
        <h3 className={classes.itemSubtitle}>
          <HelperWrapper t="user-profile-form-delete-title" ns={ETranslationNs.UserProfile} />
        </h3>
        <Button variant="contained" onClick={handleOpen} className={classes.deleteButton}>
          <HelperWrapper t="user-profile-form-delete-button" ns={ETranslationNs.UserProfile} />
        </Button>
      </div>
      <DeleteConfirmModal handleDelete={handleDelete} handleClose={handleClose} open={open} />
    </>
  )
}

export { DeleteButton }
